import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { ArrowUpRight, Wind, Droplets, Wrench, Cog, Snowflake, Flame } from "lucide-react";

const iconMap = { Wind, Droplets, Wrench, Cog, Snowflake, Flame };

export default function ServicesSection({ onlyFeatured = true, title = "Nos expertises", subtitle = "Trois métiers, une exigence" }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/services", { params: onlyFeatured ? { featured: true } : {} }).then(r => setItems(r.data));
  }, [onlyFeatured]);

  return (
    <section className="relative py-20 md:py-28 bg-[hsl(var(--background))] noise-bg" data-testid="services-section">
      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-[color:var(--brand-sky)] font-semibold mb-3">
              Services
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-[color:var(--brand-navy)] max-w-2xl leading-tight">
              {title}<br/>
              <span className="brand-gradient-text">{subtitle}</span>
            </h2>
          </div>
          <Link to="/services" className="inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--brand-navy)] hover:gap-3 transition-all group">
            Tous les services <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform"/>
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((s, i) => {
            const Icon = iconMap[s.icon] || Wrench;
            const big = i === 0;
            return (
              <Link
                key={s.id}
                to={`/services/${s.slug}`}
                className={`group relative overflow-hidden rounded-3xl bg-[hsl(var(--card))] shadow-soft shadow-hover ${big ? "lg:col-span-2 lg:row-span-1" : ""}`}
                data-testid={`service-card-${s.slug}`}
              >
                <div className={`relative overflow-hidden ${big ? "h-72 md:h-80" : "h-56"}`}>
                  {s.image_url && (
                    <img src={s.image_url} alt={s.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"/>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--brand-navy)] via-[color:var(--brand-navy)]/40 to-transparent"/>
                  <div className="absolute top-4 left-4">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/95 text-[color:var(--brand-navy)] text-xs font-bold uppercase tracking-wide">
                      <Icon className="w-3.5 h-3.5"/> {s.category || "Service"}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 text-white">
                    <h3 className="font-display text-xl md:text-2xl font-bold mb-1">{s.title}</h3>
                    <p className="text-white/85 text-sm line-clamp-2">{s.short_description}</p>
                  </div>
                </div>
                <div className="p-5 md:p-6 flex items-center justify-between">
                  <span className="text-sm text-[hsl(var(--muted-foreground))]">En savoir plus</span>
                  <span className="w-9 h-9 rounded-full bg-[color:var(--brand-navy)] text-white flex items-center justify-center group-hover:bg-[color:var(--brand-red)] transition-colors">
                    <ArrowUpRight className="w-4 h-4"/>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
